import { render, staticRenderFns } from "./prod-box.vue?vue&type=template&id=423accb3&scoped=true"
import script from "./prod-box.vue?vue&type=script&lang=js"
export * from "./prod-box.vue?vue&type=script&lang=js"
import style0 from "./prod-box.vue?vue&type=style&index=0&id=423accb3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423accb3",
  null
  
)

export default component.exports